import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatCalendarHeader } from '@angular/material/datepicker';
import dayjs from 'dayjs';

@Component({
    standalone: false,
    selector: 'custom-calendar-header',
    templateUrl: './custom-calendar-header.component.html',
    styleUrls: ['./custom-calendar-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCalendarHeaderComponent extends MatCalendarHeader<any>  {

    /** Handles user clicks on the period label. */
    currentPeriodClicked(): void {
        this.calendar.currentView = 'year';
    }

    /** Handles user clicks on the previous button. */
    customPrev(): void {
        this.previousClicked();
        this.emitFirstDay();
    }

    /** Handles user clicks on the next button. */
    customNext(): void {
        this.nextClicked()
        this.emitFirstDay();
    }

    emitFirstDay() {
        const dateValue: Date = this.calendar.activeDate;
        let firstDay = new Date(dateValue.getFullYear(), dateValue.getMonth(), 1);
        this.calendar.monthSelected.emit(firstDay);
    }

}
